module.exports = __webpack_public_path__ + "static/img/6.68befed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/6.png
// module id = BHmY
// module chunks = 0